jQuery(function($) {
  $("section.cpt-archive").each(function() {
    const $section = $(this);

    const post_type = $(this).data( 'post-type' );
    const $posts = $("#cpt-posts", $section);
    const $load_more_btn = $("button.load-more", $section);
    const $filters = $("form.cpt-archive-filters", $section);
    let current_page = 1;

    let cache = {};
    $("> div", $posts).each(function() {
      cache[$(this).data("id")] = $(this);
    });

    function load_page(page = 1) {
      $load_more_btn.attr("disabled", true);
      ThemeJS.Functions.wp_rest_request({
        endpoint: "cpt-archive/load",
        data: Object.assign(
          {
            post_type: post_type,
            paged: page,
            cached: Object.keys(cache),
          },
          Object.fromEntries(
            $("select", $filters)
              .toArray()
              .map((el) => {
                const $el = $(el);
                return [
                  $el.attr("name"),
                  $el.is(":visible") ? $el.val() : null,
                ];
              }),
          ),
        ),
        success(resp) {
          if (page == 1) {
            $posts.empty();
          }
          resp.posts.forEach((data) => {
            if (data.html ?? null) {
              cache[data.id] = $(data.html);
            }
            $posts.append(cache[data.id]);
          });
          current_page = page;
          $load_more_btn[resp.max_page > page ? "show" : "hide"]();
        },
        complete() {
          $load_more_btn.attr("disabled", !$load_more_btn.is(":visible"));
        },
      });
    }

    $load_more_btn.on("click", function() {
      load_page(current_page + 1);
    });

    $filters.on("change", "select", function() {
      jQuery("select", $filters)
        .toArray()
        .map((el) => {
          const $el = jQuery(el);
          const v = $el.is(":visible") ? $el.val() : null;
          jQuery("[name='" + $el.attr("name") + "_modal" + "']")
            .val(v)
            .trigger("change");
        });
      load_page(1);
    });
  });
});
